import {
  AccessToConnectorApollo,
  ShoppingListConnectorApollo,
  ShoppingListMarkProductConnectorApollo,
  ShoppingListOnDemandConnectorApollo,
  ShoppingListPeriodConnectorApollo,
} from '@front-activerse/common-components';
import ShoppingListIndexContainer from './ShoppingListIndexContainer';
import ShoppingListPlaceholder from './Placeholder/ShoppingListPlaceholder';
import UnauthorizedException from '../Unauthorized/UnauthorizedException';

const ShoppingListPage = ({ shoppingTipsArticleId, mealPlanNavigation }) => {
  return (
    <AccessToConnectorApollo>
      {({ loading: loadingAccess, authorized }) => {
        if (loadingAccess) return <ShoppingListPlaceholder />;

        // the shopping list covers whole days, so it follows the diet-wide
        // access date rather than the per-meal freemium flags
        if (!authorized) return <UnauthorizedException mealPlanNavigation={mealPlanNavigation} />;

        return (
          <ShoppingListPeriodConnectorApollo>
            {(periodData) => {
              if (periodData.loading) return <ShoppingListPlaceholder />;
              return (
                <ShoppingListConnectorApollo>
                  {(shoppingListData) => (
                    <ShoppingListOnDemandConnectorApollo>
                      {(shoppingListOnDemandData) => (
                        <ShoppingListMarkProductConnectorApollo
                          period={shoppingListOnDemandData.period || periodData.period}
                        >
                          {({ handleMarkProduct }) => (
                            <ShoppingListIndexContainer
                              {...{
                                handleMarkProduct,
                              }}
                              {...shoppingListData}
                              {...shoppingListOnDemandData}
                              {...periodData}
                              loading={shoppingListData.loading || periodData.loading}
                              shoppingTipsArticleId={shoppingTipsArticleId}
                            />
                          )}
                        </ShoppingListMarkProductConnectorApollo>
                      )}
                    </ShoppingListOnDemandConnectorApollo>
                  )}
                </ShoppingListConnectorApollo>
              );
            }}
          </ShoppingListPeriodConnectorApollo>
        );
      }}
    </AccessToConnectorApollo>
  );
};

export default ShoppingListPage;
